import { Box, Flex, Heading, Image, Text, VStack, StackProps, TextProps } from "@chakra-ui/react";
import React, { ReactNode } from "react";

interface MessageWithIconProps extends StackProps {
  image: string;
  title: string;
  message: React.ReactNode;
  bottomElement?: ReactNode;
  titleStyle?: TextProps["textStyle"];
  isError?: boolean;
}

export const MessageWithIcon: React.FC<MessageWithIconProps> = ({ image, title, message, bottomElement, isError, titleStyle: _titleStyle, ...props }) => {
  const color = isError ? "accent" : "primary";

  return (
    <VStack
      bg="white"
      maxW="480px"
      w="100%"
      gap="18px"
      borderRadius="24px"
      border="1px solid rgba(67,0,152,0.08)"
      boxShadow="0 24px 60px rgba(67,0,152,0.12)"
      p={{ base: "36px 26px", md: "48px 44px" }}
      mx="auto"
      textAlign="center"
      {...props}
    >
      <Flex
        w="104px"
        h="104px"
        borderRadius="full"
        align="center"
        justify="center"
        bg={isError ? "rgba(229,31,68,0.08)" : "rgba(67,0,152,0.06)"}
        mb="4px"
      >
        <Image src={image} maxH="62px" maxW="62px" />
      </Flex>

      <Heading fontSize={{ base: "24px", md: "28px" }} fontWeight="800" color={color}>
        {title}
      </Heading>

      <Box fontSize={{ base: "15px", md: "16px" }} color="gray.600" lineHeight="1.6">
        {message}
      </Box>

      {bottomElement && <Box pt="6px">{bottomElement}</Box>}
    </VStack>
  );
};
